import { render } from "./AlbumsGrid.vue?vue&type=template&id=6dc1dc24&scoped=true"
import script from "./AlbumsGrid.vue?vue&type=script&lang=js"
export * from "./AlbumsGrid.vue?vue&type=script&lang=js"

import "./AlbumsGrid.vue?vue&type=style&index=0&id=6dc1dc24&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dc1dc24"]])

export default __exports__